import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { PublicRoute } from "./Public.route";
import NotFoundView from "../views/errors/NotFoundView";
import { PrivateRoute } from "./Private.route";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import PlantsPage from "../pages/PlantsPage";
import EkloksPage from "../pages/EkloksPage";
import AccountPage from "../pages/AccountPage";
import ResetPage from "../pages/ResetPage";
import ResetConfirmPage from "../pages/ResetConfirmPage";
import DashboardPage from "../pages/DashboardPage";
import InstallersPage from "../pages/InstallersPage";
import SupportPage from "../pages/SupportPage";
import CustomersPage from "../pages/CustomersPage";
import MobileFramePage from "../pages/MobileFramePage";
import CommandListPage from "../pages/CommandListPage";
import CommandDetailPage from "../pages/CommandDetailPage";
import EventStatusListPage from "../pages/EventStatusListPage";
import BlocksSoundsPage from "../pages/BlocksSoundsPage";
import AssistancePage from "../pages/AssistancePage";
import CalendarEventPage from "../pages/CalendarEventPage";
import AddCalendarEventPage from "../pages/AddCalendarEventPage";

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <PublicRoute exact path="/" component={LoginPage} />

        <PublicRoute path="/login/:type" component={LoginPage} />
        <PublicRoute exact path="/register" component={RegisterPage} />
        <PublicRoute path="/register/:type" component={RegisterPage} />
        <PublicRoute exact path="/reset" component={ResetPage} />
        <PublicRoute path="/reset/:type" component={ResetPage} />
        <PublicRoute
          path="/reset-confirm/:type/:uid/:token"
          component={ResetConfirmPage}
        />

        <PrivateRoute path="/app/dashboard" component={DashboardPage} />
        <PrivateRoute path="/app/plants" component={PlantsPage} />
        <PrivateRoute path="/app/ekloks" component={EkloksPage} />
        <PrivateRoute path="/app/account" component={AccountPage} />
        <PrivateRoute path="/app/installers" component={InstallersPage} />
        <PrivateRoute path="/app/customers" component={CustomersPage} />
        <PrivateRoute path="/app/Support" component={SupportPage} />
        <PrivateRoute
          path="/app/mobile/frame/:eklok"
          component={MobileFramePage}
        />
        <PrivateRoute
          path="/app/command/list/:type/:eklok"
          component={CommandListPage}
        />
        <PrivateRoute
          path="/app/command/:id/:eklok"
          component={CommandDetailPage}
        />
        <PrivateRoute
          path="/app/event/list/:eklok"
          component={EventStatusListPage}
        />
        <PrivateRoute
          path="/app/blocks/sounds/:eklok"
          component={BlocksSoundsPage}
        />
        <PrivateRoute
          path="/app/assistance/:eklok"
          component={AssistancePage}
        />
        <PrivateRoute
          path="/app/calendar/event/:eklok"
          component={CalendarEventPage}
        />
        <PrivateRoute
          path="/app/add/calendar/event/:eklok"
          component={AddCalendarEventPage}
        />

        <PublicRoute path="*" component={NotFoundView} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
